module.exports = {
      id: "audio-play-usage",
      viewBox: "0 0 384 512",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#audio-play",
      toString: function () {
        return this.url;
      }
    }